module.exports = __webpack_public_path__ + "media/images/favicon-v2-6ac9a65126c52340e98e1e131f9b3a70.ico";